export const contestsApi = {
  contests: {
    queryKey: (params?: string[]) => ["contests", ...(params || [])],
    route: () => `contests`,
    methods: ["GET", "POST"],
  },
  contest: {
    queryKey: (id: number, params?: string[]) => [
      "contests",
      id,
      ...(params || []),
    ],
    route: (id: number) => `contests/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
